import { BoardInstructionTypes } from 'types/Board';
import { BoardInstruction, BoardOrder, BoardParticipant } from 'types';

import voteValues from 'constants/voteValues';

function getPointByPointInstruction(
  instructions: BoardInstruction[],
  order: BoardOrder
): string {
  const resultInstruction = instructions?.find(
    (instruction: any) => instruction?.order === order?._id
  );
  if (resultInstruction) {
    return voteValues[resultInstruction?.vote as keyof typeof voteValues]
      ?.value;
  }
  return '';
}

export default function getParticipantInstruction(
  participant: BoardParticipant,
  order: BoardOrder
): string {
  const { instructions, instructionType } = participant.delegationVote || {};

  if (instructionType === BoardInstructionTypes.ALL_YES) {
    return voteValues.YES.value;
  }
  if (instructionType === BoardInstructionTypes.ALL_NO) {
    return voteValues.NO.value;
  }
  if (instructionType === BoardInstructionTypes.ALL_ABS) {
    return voteValues.ABS.value;
  }
  if (instructionType === BoardInstructionTypes.POINT_BY_POINT) {
    if (instructions) {
      return getPointByPointInstruction(instructions, order);
    }
  }

  return '';
}
